// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Organism_Footer from "../../design-system/organism/footer/Organism_Footer.bs.js";

function Presse_Footer(Props) {
  var footerItems = Props.footerItems;
  return React.createElement(Organism_Footer.make, {
              footerItems: footerItems
            });
}

var make = Presse_Footer;

export {
  make ,
}
/* react Not a pure module */
